import { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import { logDOM } from "@testing-library/react";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import load from "../../../assets/Images/loader.gif";


const billingCycleOption = [
    // { label: "Yearly", value: "12" },
    { label: "Half-Yearly", value: "6" },
    // { label: "Quaterly", value: "3" },
];

const PriceCalculator1 = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };
    const [loading, setLoading] = useState(false);
    const [pgType, setPgType] = useState("");
    const [pgTypedetails, setPgTypedetails] = useState([]);
    const [billingCycle, setBillingCycle] = useState(billingCycleOption[0]);
    const [basePlan, setBasePlan] = useState("");
    const [basePlanDetail, setBasePlanDetail] = useState([]);
    const [smartTvCount, setSmartTvCount] = useState("");
    const [cctvCount, setCctvCount] = useState("");
    const [dvrCount, setDvrCount] = useState("");
    const [ioTDevicesCount, setIoTDevicesCount] = useState("");
    const [staticIPCount, setStaticIPCount] = useState("");
    const [devicePackCount, setDevicePackCount] = useState("");
    const [wiredLANPortsCount, setWiredLANPortsCount] = useState("");
    const [discountValueTV, setDiscountValueTV] = useState("0");
    const [discountValueCCTV, setDiscountValueCCTV] = useState("0");
    const [discountValueDVR, setDiscountValueDVR] = useState("0");
    const [discountValueIoT, setDiscountValueIoT] = useState("0");
    const [discountValueStaticIP, setDiscountValueStaticIP] = useState("0");
    const [discountValueDevicePack, setDiscountValueDevicePack] = useState("0");
    const [discountValueWiredLAN, setDiscountValueWiredLAN] = useState("0");
    const [isDiscountChecked, setIsDiscountChecked] = useState(false);

    const [isDiscountTVChecked, setIsDiscountTVChecked] = useState(false);
    const [isDiscountcctVChecked, setIsDiscountcctVChecked] = useState(false);
    const [isDiscountDvrChecked, setIsDiscountDvrChecked] = useState(false);
    const [isDiscountIotChecked, setIsDiscountIotChecked] = useState(false);
    const [isDiscountDeviceChecked, setIsDiscountDeviceChecked] = useState(false);

    const [priceTV, setPriceTV] = useState("0");
    const [priceCCTV, setPriceCCTV] = useState("0");
    const [priceDVR, setPriceDVR] = useState("0");
    const [priceIoT, setPriceIoT] = useState("0");
    const [priceStaticIP, setPriceStaticIP] = useState("0");
    const [priceDevicePack, setPriceDevicePack] = useState("0");
    const [priceWiredLAN, setPriceWiredLAN] = useState("0");






    const [basePriceDis, setBasePriceDis] = useState(""); // Discount Percentage
    const [discountedBasePrice, setDiscountedBasePrice] = useState("");
    const [basePriceDisPercent, setBasePriceDisPercent] = useState("");

    const [listPrice, setListPrice] = useState("");
    const [otcPerRoom, setOtcPerRoom] = useState("");
    const [sdPerRoom, setSdPerRoom] = useState("");
    const [recommendedPrice, setRecommendedPrice] = useState("");

    const [smartTVRes, setSmartTVRes] = useState("");
    const [ccTvRes, setCcTvRes] = useState("");
    const [dvrRes, setDvrRes] = useState("");
    const [iotRes, setIotRes] = useState("");
    const [staticIpRes, setStaticIpRes] = useState("");
    const [devicePackRes, setDevicePackRes] = useState("");
    const [wiredLanRes, setwiredLanRes] = useState("");

    // const [smartTVExtendAmount, setSmartTVExtendAmount] = useState("");
     // const [ccTvExtendAmount, setCcTvExtendAmount] = useState("");
      // const [dvrExtendAmount, setDvrExtendAmount] = useState("");
       // const [iotExtendAmount, setIotExtendAmount] = useState("");
        // const [devicePackExtendAmount, setDevicePackExtendAmount] = useState("");

    const [basePlanName, setBasePlanName] = useState("");
    const [basePlanProId, setBasePlanProId] = useState("");
    const [basePlanDes, setBasePlanDes] = useState("");
    const [smartTVProId, setSmartTVProId] = useState("");
    const [ccTvProId, setCcTvProId] = useState("");
    const [dvrProId, setDvrProId] = useState("");
    const [iotProId, setIotProId] = useState("");
    const [devicePackProId, setDevicePackProId] = useState("");

    const [selectedPlan, setSelectedPlan] = useState("");

    const [proposalCounter, setProposalCounter] = useState("");

    const [tanantTypeId, setTanantTypeId] = useState("");
    const [tableArea, setTableArea] = useState(false);
    const [oppStatus, setOppStatus] = useState("");

    const [userPriceData, setUserPriceData] = useState({
        pgName: "",
        roomCount: "",
        basePrice: "",
        basePriceDis: "",
        basePriceReason: ""
    });

    const handleChange = (e) => {
        // console.log(e.target.name, e.target.value);
        setUserPriceData({ ...userPriceData, [e.target.name]: e.target.value });
    };

    // const handlePgType = (selected) => {
    //     setPgType(selected);
    // };


    const calculateDiscountedPrice = () => {
        const discount = parseFloat(basePriceDis);

        // Subtracting absolute discount value
        const newPrice = listPrice - discount;

        // Calculating the discount percentage
        const discountPercent = (discount / listPrice) * 100;

        const listPriceper = listPrice * 15 / 100

        // console.log("listPriceper", listPriceper);




        setBasePriceDisPercent(discountPercent.toFixed(2));
        setDiscountedBasePrice(newPrice);

        // console.log(`Discount Amount: ${discount}`);
        // console.log(`Discounted Price: ${newPrice}`);
        // console.log(`Discount Percentage: ${discountPercent.toFixed(2)}%`);

        // if (discountPercent > 15) {
        //     alert("Discount cannot be more than 15%!");
        //     // toast.success("Discount cannot be more than 15%!", {
        //     //     position: toast.POSITION.BOTTOM_CENTER,
        //     //     autoClose: 1500,
        //     // });
        //     // setBasePriceDis(""); // Reset input
        //     // setDiscountedBasePrice(listPrice); // Reset price
        //     return;
        // }
    };

    const handleBasePriceDis = (e) => {
        setBasePriceDis(e.target.value);
    };

    // Update discounted price when discount input loses focus
    useEffect(() => {
        calculateDiscountedPrice();
    }, [listPrice, basePriceDis]);

    const handleBillingCycle = (selected) => {
        setBillingCycle(selected);
    };



    const handleSmartTvCount = (e) => {
        setSmartTvCount(e.target.value);
    };

    const handleCctvCount = (e) => {
        setCctvCount(e.target.value);
        if (e.target.value) setDvrCount("");
    };

    const handleDvrCount = (e) => {
        setDvrCount(e.target.value);
        if (e.target.value) setCctvCount("");
    };

    const handleIoTDevicesCount = (e) => {
        setIoTDevicesCount(e.target.value);
    };

    const handleStaticIPCount = (e) => {
        setStaticIPCount(e.target.value);
    };

    const handleDevicePackCount = (e) => {
        setDevicePackCount(e.target.value);
    };

    const handleWiredLANPortsCount = (e) => {
        setWiredLANPortsCount(e.target.value);
    };

    // const handleDiscountCheckboxChange = (event) => {
    //     setIsDiscountChecked(event.target.checked);
    // };

    // useEffect(() => {
    //     if (isDiscountChecked == true) {
    //         fetchAllDiscounts(selectedPlan);
    //         setSmartTvCount("");
    //         setCctvCount("");
    //         setDvrCount("");
    //         setIoTDevicesCount("");
    //         setDevicePackCount("");
    //     }
    // }, []);


    // console.log("isDiscountChecked", isDiscountChecked);

    const handleDiscountCheckboxChange = (event) => {
        if (!basePlan) {
            toast.warning("Please Select Base Plan", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        const isChecked = event.target.checked;
        setIsDiscountChecked(isChecked);

        if (isChecked && basePlan) {
            // Fetch discount if checkbox is checked and a plan is selected
            fetchAllDiscounts(basePlan.label);
        }
        if (isChecked) {
            setSmartTvCount("");
            setCctvCount("");
            setDvrCount("");
            setIoTDevicesCount("");
            setDevicePackCount("");
        }
    };

    const handleTVDiscountCheckChange = (event) => {
        if (!basePlan) {
            toast.warning("Please Select Base Plan", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        const isChecked = event.target.checked;
        setIsDiscountTVChecked(isChecked);

        if (isChecked && basePlan) {
            // Fetch discount if checkbox is checked and a plan is selected
            fetchAllDiscountsTv(basePlan.label);
        } else {
            setDiscountValueTV("")
            setSmartTvCount("");
        }
        if (isChecked) {
            setSmartTvCount("");
            // setCctvCount("");
            // setDvrCount("");
            // setIoTDevicesCount("");
            // setDevicePackCount("");
        }
    };

    const handleCctvDiscountCheckChange = (event) => {
        if (!basePlan) {
            toast.warning("Please Select Base Plan", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        const isChecked = event.target.checked;
        setIsDiscountcctVChecked(isChecked);

        if (isChecked && basePlan) {
            // Fetch discount if checkbox is checked and a plan is selected
            fetchAllDiscountsCctv(basePlan.label);
        }
        if (isChecked) {
            // setSmartTvCount("");
            setCctvCount("");
            // setDvrCount("");
            // setIoTDevicesCount("");
            // setDevicePackCount("");
        }
    };

    const handleDvrDiscountCheckboxChange = (event) => {
        if (!basePlan) {
            toast.warning("Please Select Base Plan", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        const isChecked = event.target.checked;
        setIsDiscountDvrChecked(isChecked);

        if (isChecked && basePlan) {
            // Fetch discount if checkbox is checked and a plan is selected
            fetchAllDiscountsDvr(basePlan.label);
        }
        if (isChecked) {
            // setSmartTvCount("");
            // setCctvCount("");
            setDvrCount("");
            // setIoTDevicesCount("");
            // setDevicePackCount("");
        }
    };


    const handleIotDiscountCheckboxChange = (event) => {
        if (!basePlan) {
            toast.warning("Please Select Base Plan", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        const isChecked = event.target.checked;
        setIsDiscountIotChecked(isChecked);

        if (isChecked && basePlan) {
            // Fetch discount if checkbox is checked and a plan is selected
            fetchAllDiscountsIot(basePlan.label);
        }
        if (isChecked) {
            // setSmartTvCount("");
            // setCctvCount("");
            // setDvrCount("");
            setIoTDevicesCount("");
            // setDevicePackCount("");
        }
    };

    const handleDeviceDiscountCheckboxChange = (event) => {
        if (!basePlan) {
            toast.warning("Please Select Base Plan", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        const isChecked = event.target.checked;
        setIsDiscountDeviceChecked(isChecked);

        // console.log(" discountValueDevicePack", discountValueDevicePack);

        if (isChecked && basePlan) {
            // Fetch discount if checkbox is checked and a plan is selected
            fetchAllDiscountsDevice(basePlan.label);
        } else {
            setDiscountValueDevicePack("")
            setDevicePackCount("");
        }
        if (isChecked) {
            // setSmartTvCount("");
            // setCctvCount("");
            // setDvrCount("");
            // setIoTDevicesCount("");
            setDevicePackCount("");
        }
    };





    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const navigate = useNavigate();

    const redirectOpportunity = () => {
        navigate(`/BusinessPgOpp?OppId=${OppId}`);
    };

    useEffect(() => {
        const fetchGetopportunity = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();

                setOppStatus(result.Response?.Data[0]?.Status);
                // console.log("API Response :", result.Response.Data[0].PgInfo);
                setUserPriceData({
                    pgName: result.Response?.Data[0]?.PgInfo.PGName,
                    roomCount: result.Response?.Data[0]?.PgInfo.NumberofRooms
                })

                setProposalCounter(result.Response.Data[0]?.PgInfo.ProposalCounter);
                if (result?.Response?.Data[0].PgInfo?.TenantType) {
                    setTanantTypeId(result?.Response?.Data[0]?.PgInfo?.TenantType);
                }

                let tanantPGtype = result?.Response?.Data[0]?.PgInfo.TenantType;
                try {
                    const apiUrl = process.env.REACT_APP_API_URL_3;
                    const requestData = {
                        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        Action: "getPGType",
                    };

                    const response = await fetch(apiUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(requestData),
                    });

                    const result = await response.json();

                    // console.log("API Response :", result);
                    const pgTanantType = result?.Response?.map((option) => ({
                        label: option?.type_name,
                        value: option?.crm_plan_id,
                    }));
                    const filterPgType = pgTanantType?.find((data) => data.value == tanantPGtype)
                    // console.log("filterPgType",filterPgType);

                    setPgType({
                        label: filterPgType?.label,
                        value: filterPgType.value,
                    });
                } catch (error) {
                    console.error("Error fetching data:", error.message);
                } finally {
                }

            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
            }
        };
        fetchGetopportunity();
    }, []);




    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const requestData = {
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    Action: "getPGType",
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();

                // console.log("API Response :", result);
                const pgType = result.Response.map((option) => ({
                    label: option.type_name,
                    value: option.crm_plan_id,
                }));
                setPgTypedetails(pgType);
            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
            }
        };

        fetchData();
    }, []);


    // console.log("pgType",pgType);  

    // console.log("tanantTypeId", tanantTypeId)
    useEffect(() => {
        const fetchGetPlans = async () => {

            try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const requestData = {
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    Action: "getPlans",
                    pgType: tanantTypeId ? tanantTypeId : ""
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                // console.log("Plan Response:", result.Response);


                const plans = result?.Response?.map((plan) => ({
                    label: plan.description,
                    value: plan.id,
                }));
                setBasePlanDetail(plans);

            } catch (error) {
                console.error("Error fetching Plans:", error.message);
            }
        };

        fetchGetPlans();
    }, [tanantTypeId]);



    const handlePgType = async (selectedOption) => {
        // console.log("selectedOption", selectedOption);
        // setPgType(selectedOption);

        // if (!selectedOption) return;

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "getPlans",
                pgType: selectedOption.value,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);


            const plans = result?.Response?.map((plan) => ({
                label: plan.plan_name,
                value: plan.id,
            }));
            setBasePlanDetail(plans);





        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };


    const handleBasePlan = async (selectedOption) => {
        // console.log("Selected Base Plan:", selectedOption);
        setBasePlan(selectedOption);

        if (!selectedOption) return;

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "getPlans",
                pgType: pgType.value, // Use the selected PG Type
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();



            const selectedPlan = result?.Response?.find(plan => plan.description == selectedOption.label);

            setSelectedPlan(selectedPlan);
            // console.log("selectedPlan.list_price1",selectedPlan);
            setBasePriceDis("")
            setSmartTvCount("")
            setCctvCount("")
            setDvrCount("")
            setIoTDevicesCount("")
            setDevicePackCount("")

            if (selectedPlan) {
                // console.log("selectedPlan.list_price2", selectedPlan.list_price);
                setBasePlanName(selectedPlan.plan_name)
                setBasePlanProId(selectedPlan.crm_product_id)
                setBasePlanDes(selectedPlan.description)
                setListPrice(selectedPlan.list_price);
                // console.log("selectedPlan.list_price3", selectedPlan.list_price);

                setOtcPerRoom(selectedPlan.otc_per_room || 0);
                setSdPerRoom(selectedPlan.sd_per_room || 0);
                setRecommendedPrice(selectedPlan.recommended_price || 0);
            } else {
                console.warn("No matching plan found.");
            }

            // Fetch discount values in parallel
            await Promise.all([
                fetchPriceAddOn("TV", selectedOption.label, setPriceTV),
                fetchPriceAddOn("CCTV", selectedOption.label, setPriceCCTV),
                fetchPriceAddOn("DVR", selectedOption.label, setPriceDVR),
                fetchPriceAddOn("IOT", selectedOption.label, setPriceIoT),
                fetchPriceAddOn("Static", selectedOption.label, setPriceStaticIP),
                fetchPriceAddOn("Device", selectedOption.label, setPriceDevicePack),
                fetchPriceAddOn("LAN", selectedOption.label, setPriceWiredLAN),

                // console.log("result.Response[0].crm_product_id",result.Response[0].crm_product_id)

                fetchPriceAddOn("TV", selectedOption.label, setPriceTV, setSmartTVProId),
                fetchPriceAddOn("CCTV", selectedOption.label, setPriceCCTV, setCcTvProId),
                fetchPriceAddOn("DVR", selectedOption.label, setPriceDVR, setDvrProId),
                fetchPriceAddOn("IOT", selectedOption.label, setPriceIoT, setIotProId),
                fetchPriceAddOn("Device", selectedOption.label, setPriceDevicePack, setDevicePackProId),
            ]);

            if (isDiscountChecked) {
                fetchAllDiscounts(selectedOption.label);
                setSmartTvCount("");
                setCctvCount("");
                setDvrCount("");
                setIoTDevicesCount("");
                setDevicePackCount("");

            }

        } catch (error) {
            console.error("Error fetching Plans:", error);
        }
    };









    const fetchPriceAddOn = async (addOnType, planName, setPrice, setProductId) => {
        if (!planName) return;

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "getPriceAddOn",
                "addOnType": addOnType,
                "planName": basePlanName

            }

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log(`${addOnType} Discount Response:`, result.Response[0].list_price);

            // if (
            //     result.Response &&
            //     Array.isArray(result.Response) &&
            //     result.Response.length > 0
            // ) {
            //     setPrice(result.Response[0].list_price);
            // } else {
            //     setPrice("0");
            // }

            if (result.Response && Array.isArray(result.Response) && result.Response.length > 0) {
                setPrice(result.Response[0].list_price || "0");  // Set price
                if (setProductId) {
                    setProductId(result.Response[0].crm_product_id || "");  // Set product ID
                }
            } else {
                setPrice("0"); // Default to 0 if no Price found
                if (setProductId) {
                    setProductId(""); // Default to empty if no product ID found
                }
            }
        } catch (error) {
            console.error(`Error fetching ${addOnType} Price:`, error.message);
        }
    };

    // { console.log("basePlanProId", basePlanProId) }
    // { console.log("listPrice", listPrice) }
    // { console.log("otcPerRoom", otcPerRoom) }
    // { console.log("sdPerRoom", sdPerRoom) }
    // { console.log("recommendedPrice", recommendedPrice) }

    const fetchDiscount = async (addOnType, planName, setDiscount) => {
        if (!planName) return;

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "getPercentage",
                addOnType: addOnType,
                planName: basePlanName,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log(`${addOnType} Discount Response:`, result.Response[0].discount);

            if (
                result.Response &&
                Array.isArray(result.Response) &&
                result.Response.length > 0
            ) {
                setDiscount(result.Response[0].discount);
            } else {
                // alert("102");
                setDiscount("0"); // Default to 0 if no discount found
            }
        } catch (error) {
            console.error(`Error fetching ${addOnType} discount:`, error.message);
        }
    };

    const fetchAllDiscounts = async (planName) => {
        if (!planName) return;
        try {
            await Promise.all([
                fetchDiscount("TV", planName, setDiscountValueTV),
                fetchDiscount("CCTV", planName, setDiscountValueCCTV),
                fetchDiscount("DVR", planName, setDiscountValueDVR),
                fetchDiscount("IOT", planName, setDiscountValueIoT),
                fetchDiscount("Static", planName, setDiscountValueStaticIP),
                fetchDiscount("Device", planName, setDiscountValueDevicePack),
                fetchDiscount("LAN", planName, setDiscountValueWiredLAN),
            ]);
        } catch (error) {
            console.error("Error fetching discounts:", error.message);
        }
    };


    const fetchAllDiscountsTv = async (planName) => {
        if (!planName) return;
        try {
            await Promise.all([
                fetchDiscount("TV", planName, setDiscountValueTV),
                // fetchDiscount("CCTV", planName, setDiscountValueCCTV),
                // fetchDiscount("DVR", planName, setDiscountValueDVR),
                // fetchDiscount("IOT", planName, setDiscountValueIoT),
                // fetchDiscount("Static", planName, setDiscountValueStaticIP),
                // fetchDiscount("Device", planName, setDiscountValueDevicePack),
                // fetchDiscount("LAN", planName, setDiscountValueWiredLAN),
            ]);
        } catch (error) {
            console.error("Error fetching discounts:", error.message);
        }
    };

    const fetchAllDiscountsCctv = async (planName) => {
        if (!planName) return;
        try {
            await Promise.all([
                // fetchDiscount("TV", planName, setDiscountValueTV),
                fetchDiscount("CCTV", planName, setDiscountValueCCTV),
                // fetchDiscount("DVR", planName, setDiscountValueDVR),
                // fetchDiscount("IOT", planName, setDiscountValueIoT),
                // fetchDiscount("Static", planName, setDiscountValueStaticIP),
                // fetchDiscount("Device", planName, setDiscountValueDevicePack),
                // fetchDiscount("LAN", planName, setDiscountValueWiredLAN),
            ]);
        } catch (error) {
            console.error("Error fetching discounts:", error.message);
        }
    };

    const fetchAllDiscountsDvr = async (planName) => {
        if (!planName) return;
        try {
            await Promise.all([
                // fetchDiscount("TV", planName, setDiscountValueTV),
                // fetchDiscount("CCTV", planName, setDiscountValueCCTV),
                fetchDiscount("DVR", planName, setDiscountValueDVR),
                // fetchDiscount("IOT", planName, setDiscountValueIoT),
                // fetchDiscount("Static", planName, setDiscountValueStaticIP),
                // fetchDiscount("Device", planName, setDiscountValueDevicePack),
                // fetchDiscount("LAN", planName, setDiscountValueWiredLAN),
            ]);
        } catch (error) {
            console.error("Error fetching discounts:", error.message);
        }
    };

    const fetchAllDiscountsIot = async (planName) => {
        if (!planName) return;
        try {
            await Promise.all([
                // fetchDiscount("TV", planName, setDiscountValueTV),
                // fetchDiscount("CCTV", planName, setDiscountValueCCTV),
                // fetchDiscount("DVR", planName, setDiscountValueDVR),
                fetchDiscount("IOT", planName, setDiscountValueIoT),
                // fetchDiscount("Static", planName, setDiscountValueStaticIP),
                // fetchDiscount("Device", planName, setDiscountValueDevicePack),
                // fetchDiscount("LAN", planName, setDiscountValueWiredLAN),
            ]);
        } catch (error) {
            console.error("Error fetching discounts:", error.message);
        }
    };


    const fetchAllDiscountsDevice = async (planName) => {
        if (!planName) return;
        try {
            await Promise.all([
                // fetchDiscount("TV", planName, setDiscountValueTV),
                // fetchDiscount("CCTV", planName, setDiscountValueCCTV),
                // fetchDiscount("DVR", planName, setDiscountValueDVR),
                // fetchDiscount("IOT", planName, setDiscountValueIoT),
                // fetchDiscount("Static", planName, setDiscountValueStaticIP),
                fetchDiscount("Device", planName, setDiscountValueDevicePack),
                // fetchDiscount("LAN", planName, setDiscountValueWiredLAN),
            ]);
        } catch (error) {
            console.error("Error fetching discounts:", error.message);
        }
    };


    const handleBlurSmartTvCount = async () => {
        // console.log("Smart TV Count blurred, fetching discount...");
        // await fetchDiscount("TV", basePlan.label, setDiscountValueTV);
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "smartTV",
                tvCount: smartTvCount,
                discount: discountValueTV,
                planName: basePlanName,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setSmartTVRes(result.Response)
        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };

    const handleBlurCctvCount = async () => {
        // await fetchDiscount("CCTV", basePlan.label, setDiscountValueCCTV);
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "cctvCamera",
                discount: discountValueCCTV,
                cctvCount: cctvCount,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setCcTvRes(result.Response);
        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };

    const handleBlurDvrCount = async () => {
        // await fetchDiscount("DVR", basePlan.label, setDiscountValueDVR);
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "DVR_NVR",
                discount: discountValueDVR,
                cctvCount: dvrCount,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setDvrRes(result.Response);
        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };

    const handleBlurIoTDevicesCount = async () => {
        // await fetchDiscount("IOT", basePlan.label, setDiscountValueIoT);
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "IOT_device",
                discount: discountValueIoT,
                IOTcount: ioTDevicesCount,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setIotRes(result.Response);
        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };

    const handleBlurStaticIPCount = async () => {
        // await fetchDiscount("Static", basePlan.label, setDiscountValueStaticIP);
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "staticIP",
                discount: discountValueStaticIP,
                staticIP: staticIPCount,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setStaticIpRes(result.Response);
        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };

    const handleBlurDevicePackCount = async () => {
        // await fetchDiscount("Device",basePlan.label,setDiscountValueDevicePack);
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "devicePack",
                "device": devicePackCount,
                "discount": discountValueDevicePack,
                "noOfrooms": userPriceData.roomCount
            }

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setDevicePackRes(result.Response);
        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };

    const handleBlurWiredLANCount = async () => {

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "wiredLAN_PORT",
                discount: discountValueWiredLAN,
                LANport: wiredLANPortsCount,
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            // console.log("Plan Response:", result.Response);
            setwiredLanRes(result.Response);
        } catch (error) {
            console.error("Error fetching Plans:", error.message);
        }
    };







    const handleCreateProduct = async () => {

        if (basePriceDis > 50 && basePriceDis <= 100) {
            if (!userPriceData.basePriceReason) {
                toast.warning("Please Select Base Price Discount Reason", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } else {
            try {
                setLoading(true)
                const apiUrl = process.env.REACT_APP_API_URL;

                // Create an array dynamically based on device counts
                let addOns = [];

                if (smartTvCount) {
                    addOns.push({
                        ProductID: smartTVProId,
                        Quantity: smartTvCount,
                        PricePerUnit: TvPriceAfterDis ? TvPriceAfterDis : "0",
                        Discount: discountValueTV || "",
                        Extendedamount: smartTVRes?.PriceAfterDiscount ? String(smartTVRes.PriceAfterDiscount) : "",
                    });
                }

                if (cctvCount) {
                    addOns.push({
                        ProductID: ccTvProId,
                        Quantity: cctvCount,
                        PricePerUnit: priceCCTV,
                        Discount: discountValueCCTV || "",
                        Extendedamount: ccTvRes?.PriceAfterDiscount ? String(ccTvRes?.PriceAfterDiscount) : "",
                    });
                }

                if (dvrCount) {
                    addOns.push({
                        ProductID: dvrProId,
                        Quantity: dvrCount,
                        PricePerUnit: priceDVR,
                        Discount: discountValueDVR || "",
                        Extendedamount: dvrRes?.PriceAfterDiscount ? String(dvrRes?.PriceAfterDiscount) : "",
                    });
                }

                if (ioTDevicesCount) {
                    addOns.push({
                        ProductID: iotProId,
                        Quantity: ioTDevicesCount,
                        PricePerUnit: priceIoT,
                        Discount: discountValueIoT,
                        Extendedamount: iotRes?.PriceAfterDiscount ? String(iotRes?.PriceAfterDiscount) : "",
                    });
                }

                if (devicePackCount) {
                    addOns.push({
                        ProductID: devicePackProId,
                        Quantity: devicePackCount,
                        PricePerUnit: discountValueDevicePack == "0" ? priceDevicePack : devicePackAfterDis,
                        Discount: discountValueDevicePack || "",
                        Extendedamount: devicePackRes?.TotalPriceIncRooms ? String(devicePackRes?.TotalPriceIncRooms) : "",
                    });
                }
                const requestData = {
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    Action: "createOpportunityProductPG",
                    UserName: sessionStorage.getItem("userName"),
                    Password: sessionStorage.getItem("password"),
                    Baseplan: {
                        OpportunityID: OppId,
                        ProductID: basePlanProId,
                        BaseFloorPriceDiscount: basePriceDis,
                        RC: discountedBasePrice ? userPriceData.roomCount * discountedBasePrice : userPriceData.roomCount * listPrice,
                        OTC: otcPerRoombased ? String(otcPerRoombased) : "",
                        SD: sdPerRoombased ? String(sdPerRoombased) : "",
                        // TotalAmount: totalReccurringAmount.toFixed(2),
                        TotalRecurringPrice: totalReccurringAmountNew.toFixed(2),
                        BillingAmount: billingAmount ? String(billingAmount) : "",
                        EffectivePrice: effectivePrice.toFixed(2)
                    },
                    AddOn: addOns, // Dynamic AddOns based on user input
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                // console.log("Plan Response:", result.Response);
                // console.log("basePriceDisPercent", basePriceDisPercent);

                if (result.Response.StatusCode == 200) {
                    toast.success("Proposal creation in progress. Once done, this will be emailed to you & customer. You can refer this under Proposal section in Opportunity", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setTableArea(true);
                    if (basePriceDis > 50 && basePriceDis <= 100) {
                        try {
                            const apiUrl = process.env.REACT_APP_API_URL;
                            const requestData = {
                                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                "Action": "createApprovals",
                                "userName": sessionStorage.getItem("userName"),
                                "password": sessionStorage.getItem("password"),
                                "OppId": OppId,
                                "Reason": userPriceData.basePriceReason
                            }
                            const response = await fetch(apiUrl, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(requestData),
                            });

                            const result = await response.json();
                            // console.log("Plan Response:", result.Response);
                            if (result?.Response?.StatusCode == 200) {
                                toast.success(result?.Response?.Message, {
                                    position: toast.POSITION.BOTTOM_CENTER,
                                    autoClose: 1500,
                                });
                            }

                        } catch (error) {
                            console.error("Error fetching Plans:", error.message);
                        }
                    }
                } else {
                    toast.warning(result?.Response?.Message, {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                }

            } catch (error) {
                console.error("Error fetching Plans:", error.message);
            } finally {
                setLoading(false)
                // setTimeout(() => {
                //     window.location.reload()
                // }, 1500);
            }
        }
    }





    const handleUpdateProduct = async () => {
        if (basePriceDis > 50 && basePriceDis <= 100) {
            if (!userPriceData.basePriceReason) {
                toast.warning("Please Select Base Price Discount Reason", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } else {
            try {
                setLoading(true)
                const apiUrl = process.env.REACT_APP_API_URL;

                // Create an array dynamically based on device counts
                let addOns = [];

                if (smartTvCount) {
                    addOns.push({
                        ProductID: smartTVProId,
                        Quantity: smartTvCount,
                        PricePerUnit: TvPriceAfterDis ? TvPriceAfterDis : "0",
                        Discount: discountValueTV || "",
                        Extendedamount: smartTVRes?.PriceAfterDiscount ? String(smartTVRes.PriceAfterDiscount) : "",
                    });
                }

                if (cctvCount) {
                    addOns.push({
                        ProductID: ccTvProId,
                        Quantity: cctvCount,
                        PricePerUnit: priceCCTV,
                        Discount: discountValueCCTV || "",
                        Extendedamount: ccTvRes?.PriceAfterDiscount ? String(ccTvRes?.PriceAfterDiscount) : "",
                    });
                }

                if (dvrCount) {
                    addOns.push({
                        ProductID: dvrProId,
                        Quantity: dvrCount,
                        PricePerUnit: priceDVR,
                        Discount: discountValueDVR || "",
                        Extendedamount: dvrRes?.PriceAfterDiscount ? String(dvrRes?.PriceAfterDiscount) : "",
                    });
                }

                if (ioTDevicesCount) {
                    addOns.push({
                        ProductID: iotProId,
                        Quantity: ioTDevicesCount,
                        PricePerUnit: priceIoT,
                        Discount: discountValueIoT,
                        Extendedamount: iotRes?.PriceAfterDiscount ? String(iotRes?.PriceAfterDiscount) : "",
                    });
                }

                if (devicePackCount) {
                    addOns.push({
                        ProductID: devicePackProId,
                        Quantity: devicePackCount,
                        PricePerUnit: discountValueDevicePack == "0" ? priceDevicePack : devicePackAfterDis,
                        Discount: discountValueDevicePack || "",
                        Extendedamount: devicePackRes?.TotalPriceIncRooms ? String(devicePackRes?.TotalPriceIncRooms) : "",
                    });
                }

                const requestData = {
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    Action: "updateOpportunityProductPG",
                    UserName: sessionStorage.getItem("userName"),
                    Password: sessionStorage.getItem("password"),
                    Baseplan: {
                        OpportunityID: OppId,
                        ProductID: basePlanProId,
                        BaseFloorPriceDiscount: basePriceDis,
                        RC: discountedBasePrice ? userPriceData.roomCount * discountedBasePrice : userPriceData.roomCount * listPrice,
                        OTC: otcPerRoombased ? String(otcPerRoombased) : "",
                        SD: sdPerRoombased ? String(sdPerRoombased) : "",
                        // TotalAmount: totalReccurringAmount.toFixed(2),
                        TotalRecurringPrice: totalReccurringAmountNew.toFixed(2),
                        BillingAmount: billingAmount ? String(billingAmount) : "",
                        EffectivePrice: effectivePrice.toFixed(2)
                    },
                    AddOn: addOns, // Dynamic AddOns based on user input
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                // console.log("Plan Response:", result.Response);

                if (result.Response.StatusCode == 200) {
                    toast.success("Proposal creation in progress. Once done, this will be emailed to you & customer. You can refer this under Proposal section in Opportunity", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setTableArea(true);
                    if (basePriceDis > 50 && basePriceDis <= 100) {
                        try {
                            const apiUrl = process.env.REACT_APP_API_URL;
                            const requestData = {
                                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                "Action": "createApprovals",
                                "userName": sessionStorage.getItem("userName"),
                                "password": sessionStorage.getItem("password"),
                                "OppId": OppId,
                                "Reason": userPriceData.basePriceReason
                            }
                            const response = await fetch(apiUrl, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(requestData),
                            });

                            const result = await response.json();
                            // console.log("Plan Response:", result.Response);
                            if (result?.Response?.StatusCode == 200) {
                                toast.success(result?.Response?.Message, {
                                    position: toast.POSITION.BOTTOM_CENTER,
                                    autoClose: 1500,
                                });
                            }

                        } catch (error) {
                            console.error("Error fetching Plans:", error.message);
                        }
                    }
                } else {
                    toast.warning(result?.Response?.Message, {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                }

            } catch (error) {
                console.error("Error fetching Plans:", error.message);
            } finally {
                setLoading(false)
                // setTimeout(() => {
                //     window.location.reload()
                // }, 1500);
            }
        }
    }




    const handleCalculate = () => {
        setTableArea(true);
    }



    let totalAmount = userPriceData.roomCount * listPrice * billingCycle?.value;


    let totalAmountBase = userPriceData.roomCount * listPrice;






    let SmartTvPriceAfterDis = smartTVRes?.PriceAfterDiscount / smartTvCount
    let TvPriceAfterDis = !isNaN(SmartTvPriceAfterDis) && SmartTvPriceAfterDis !== null && SmartTvPriceAfterDis !== undefined && SmartTvPriceAfterDis.toFixed(2)
    // console.log("TvPriceAfterDis", TvPriceAfterDis);

    let devicePackPriceAfterDis = (priceDevicePack * discountValueDevicePack) / 100

    let devicePackAfterDis = !isNaN(devicePackPriceAfterDis) && devicePackPriceAfterDis !== null && devicePackPriceAfterDis !== undefined && devicePackPriceAfterDis.toFixed(2)
    // let 


    let sdPerRoombased = sdPerRoom * userPriceData.roomCount;
    let otcPerRoombased = otcPerRoom * userPriceData.roomCount;




    let basePlanTotal = discountedBasePrice ? userPriceData.roomCount * discountedBasePrice : userPriceData.roomCount * listPrice
    let tvSmartTotal = smartTvCount ? (+smartTVRes?.PriceAfterDiscount || 0) : "0"
    let cctvTotal = cctvCount ? (+ccTvRes?.PriceAfterDiscount || 0) : "0"
    let dvrTotal = dvrCount ? (+dvrRes?.PriceAfterDiscount || 0) : "0"
    let iotTotal = iotRes?.PriceAfterDiscount || 0
    let devicePackTotal = devicePackCount ? (+devicePackRes?.TotalPriceIncRooms || 0) : "0"

    let totalReccurringAmount =
        (+totalAmountBase || 0) +
        (+smartTVRes?.PriceAfterDiscount || 0) +
        (+ccTvRes?.PriceAfterDiscount || 0) +
        (+dvrRes?.PriceAfterDiscount || 0) +
        (+iotRes?.PriceAfterDiscount || 0) +
        (+devicePackRes?.TotalPriceIncRooms || 0);

    let totalReccurringAmountNew =
        (+basePlanTotal || 0) +
        (+tvSmartTotal || 0) +
        (+cctvTotal || 0) +
        (+dvrTotal || 0) +
        (+iotTotal || 0) +
        (+devicePackTotal || 0);


    let billingAmt = totalReccurringAmountNew * 6
    let billingAmount = billingAmt.toFixed(2)
    let effectivePrice = totalReccurringAmountNew / userPriceData.roomCount

    // const customStyles = {
    //     menu: (provided) => ({
    //         ...provided,
    //         maxHeight: "200px", // Makes dropdown scrollable
    //         overflowY: "auto",
    //     }),
    //     option: (provided) => ({
    //         ...provided,
    //         whiteSpace: "normal", // Allows text to break into multiple lines
    //         wordWrap: "break-word",
    //     }),
    // };


    const customOption = (props) => {
        const { data, innerRef, innerProps, isFocused } = props;
        return (
            <div
                ref={innerRef}
                {...innerProps}
                // data-tooltip-id={`tooltip-${data.value}`}
                data-tooltip-content={data.label}
                style={{
                    backgroundColor: isFocused ? "#cddbf7" : "white", // Highlight on hover
                    color: isFocused ? "black" : "black",
                    padding: "10px",
                    // cursor: "pointer",
                }}
            >
                {data.label}
                {/* <Tooltip id={`tooltip-${data.value}`} /> */}
            </div>
        );
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "35px",
            whiteSpace: "normal",
            overflow: "visible",
        }),
        menu: (provided) => ({
            ...provided,
            maxHeight: "200px", // Ensures dropdown is scrollable
            overflowY: "auto",
            scrollbarWidth: "thin",
            WebkitOverflowScrolling: "touch", // Enables smooth scrolling on iOS
        }),
        singleValue: (provided) => ({
            ...provided,
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "clip",
        }),
        option: (provided, { isFocused }) => ({
            ...provided,
            backgroundColor: isFocused ? "#007bff" : "white",
            color: isFocused ? "white" : "black",
            cursor: "pointer",
        }),
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };



    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectOpportunity}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-2">PG Price Calculator</span>
                </div>
            </div>

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={load} alt="loading...."></img>
                    </div>
                </div>
            ) : (

                <div className="container-fluid form-container">
                    <div className="container shadow mb-3 bg-body rounded mt-4" id="form1">
                        <form className="lead-form p-2">
                            <div className="container text-light Header-style border p-1 mt-3">
                                <span>PG Details</span>
                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className=" mt-4">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            PG Name*
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter PG Name"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="pgName"
                                            name="pgName"
                                            value={userPriceData.pgName}
                                            onChange={handleChange}
                                            style={{ backgroundColor: "transparent" }}
                                            readOnly
                                        />

                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            Room Count*
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Room Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="roomCount"
                                            name="roomCount"
                                            value={userPriceData.roomCount}
                                            onChange={handleChange}
                                            style={{ backgroundColor: "transparent" }}
                                            readOnly
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    // &&  (userPriceData.roomCount < 9 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="">
                                        <label className="select-search-label mt-3">
                                            Billing Cycle
                                        </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            placeholder="Select Option"
                                            id="billingCycle"
                                            name="billingCycle"
                                            styles={style}
                                            value={billingCycle}
                                            onChange={handleBillingCycle}
                                            options={billingCycleOption.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="">
                                        <label className="select-search-label mt-3">
                                            PG Tenant Type
                                        </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            placeholder="Select Option"
                                            id="pgType"
                                            name="pgType"
                                            styles={style}
                                            value={pgType}
                                            onChange={handlePgType}
                                            isDisabled={true}
                                            options={pgTypedetails.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>
                                </div>

                                {/* {console.log("pgType", pgType.value)} */}




                                <div className="col-12 col-md-6">
                                    <div className="">
                                        <label className="select-search-label mt-3">Base Plan</label>
                                        {/* <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        placeholder="Select Option"
                                        id="basePlan"
                                        name="basePlan"
                                        // styles={style}
                                        styles={customStyles}
                                        isSearchable = {false}
                                        value={basePlan}
                                        onChange={handleBasePlan}
                                        options={basePlanDetail.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    /> */}
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            placeholder="Select Option"
                                            id="basePlan"
                                            name="basePlan"
                                            styles={customStyles}
                                            components={{ Option: customOption }}
                                            value={basePlan}
                                            onChange={handleBasePlan}
                                            options={basePlanDetail.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                            isSearchable={false}
                                            menuPlacement="auto" // Prevents dropdown from cutting off
                                            menuPosition="fixed"
                                            isDisabled={oppStatus !== "Open"}
                                        />
                                    </div>
                                </div>



                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            List Price
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Base Price"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="basePrice"
                                            name="basePrice"
                                            // value={userPriceData.basePrice}
                                            value={listPrice}
                                        // onChange={handleChange}
                                        />

                                    </div>
                                </div>


                                {/* {console.log("listPrice", listPrice)} */}

                                {proposalCounter != "" &&
                                    <div className="col-12 col-md-6">
                                        <div className="mt-4">
                                            <label htmlFor="pgName1" className="pg-lable-style">
                                                Add Base price Discount
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Enter Base price Discount"
                                                className="form-control input-text form-control-sm pg-input-style"
                                                id="basePriceDis"
                                                name="basePriceDis"
                                                value={basePriceDis}
                                                onChange={handleBasePriceDis}
                                                onBlur={calculateDiscountedPrice}
                                                disabled={oppStatus !== "Open"}
                                                style={{ background: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const input = e.target.value;

                                                    // Prevent entering '0' as the first character
                                                    if (input.length === 0 && e.key === "0") {
                                                        e.preventDefault();
                                                        return;
                                                    }
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key))
                                                        //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>
                                        {basePriceDis > 100 &&
                                            <p className="mt-1" style={{ marginLeft: "20px", color: "red" }}>Discount cannot be more than 100</p>
                                        }

                                        {basePriceDis > 50 && basePriceDis <= 100 &&
                                            <p className="mt-1 text-primary" style={{ marginLeft: "20px" }}>Approval Request will be Generated</p>
                                        }
                                    </div>}

                                {!isNaN(discountedBasePrice) && discountedBasePrice !== null && discountedBasePrice !== undefined && (
                                    <div className="col-12 col-md-6">
                                        <div className="mt-4">
                                            <label htmlFor="pgName1" className="pg-lable-style">
                                                Reason Of Base price Discount
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Enter Base price Discount"
                                                className="form-control input-text form-control-sm pg-input-style"
                                                id="basePriceReason"
                                                name="basePriceReason"
                                                value={userPriceData.basePriceReason}
                                                onChange={handleChange}


                                            />
                                        </div>

                                    </div>)}

                                {/* { console.log("basePriceReason",userPriceData.basePriceReason)} */}



                                {!isNaN(discountedBasePrice) && discountedBasePrice !== null && discountedBasePrice !== undefined && (
                                    <div className="col-12 m-3">
                                        <p className=""><strong>Discounted Base Price: {discountedBasePrice}</strong></p>
                                    </div>
                                )}



                            </div>

                            <div className="container text-light Header-style border p-1 mt-4">
                                <span>Add-On Plans</span>
                                {/* {proposalCounter != "" &&
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="applyDiscount"
                                        checked={isDiscountChecked}
                                        onChange={handleDiscountCheckboxChange}

                                    />
                                    <label className="form-check-label" htmlFor="applyDiscount">
                                        Apply Discount
                                    </label>
                                </div>} */}
                            </div>

                            <div className="row">


                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="smartTvCount" className="pg-lable-style">
                                            Smart TV Count
                                            {priceTV != "0" && <span> ({priceTV} per room)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="smartTvCount"
                                            name="smartTvCount"
                                            value={smartTvCount}
                                            onChange={handleSmartTvCount}
                                            onBlur={handleBlurSmartTvCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                        {proposalCounter != "" &&
                                            <div className="form-check m-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="applyDiscount"
                                                    checked={isDiscountTVChecked}
                                                    onChange={handleTVDiscountCheckChange}
                                                />
                                                <label className="form-check-label" htmlFor="applyDiscount">
                                                    Apply Discount
                                                </label>
                                            </div>}

                                        {isDiscountTVChecked && (
                                            <span
                                                className="input-group-text mt-2"
                                                style={{ marginLeft: "10px", fontWeight: "bold" }}
                                            >
                                                Discount : {discountValueTV}
                                                {"%"}

                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* {console.log("smartTvCount",smartTvCount)} */}



                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="cctvCount" className="pg-lable-style">
                                            CCTV Count
                                            {priceCCTV != "0" && <span> ({priceCCTV} per Unit)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="cctvCount"
                                            name="cctvCount"
                                            value={cctvCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onChange={handleCctvCount}
                                            onBlur={handleBlurCctvCount}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                        {/* {console.log("cctvCount",cctvCount)} */}


                                        {/* {proposalCounter != "" &&
                                        <div className="form-check m-3">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="applyDiscount"
                                                checked={isDiscountcctVChecked}
                                                onChange={handleCctvDiscountCheckChange}
                                            />
                                            <label className="form-check-label" htmlFor="applyDiscount">
                                                Apply Discount
                                            </label>
                                        </div>} */}

                                        {isDiscountcctVChecked && (
                                            <span
                                                className="input-group-text mt-2"
                                                style={{ marginLeft: "10px", fontWeight: "bold" }}
                                            >
                                                Discount : {discountValueCCTV}
                                                {"%"}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="dvrCount" className="pg-lable-style">
                                            DVR Count
                                            {priceDVR != "0" && <span> ({priceDVR} per Unit)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="dvrCount"
                                            name="dvrCount"
                                            value={dvrCount}
                                            onChange={handleDvrCount}
                                            onBlur={handleBlurDvrCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                        {/* {proposalCounter != "" &&
                                        <div className="form-check m-3">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="applyDiscount"
                                            checked={isDiscountDvrChecked}
                                            onChange={handleDvrDiscountCheckboxChange}
                                            />
                                            <label className="form-check-label" htmlFor="applyDiscount">
                                                Apply Discount
                                            </label>
                                        </div>} */}

                                        {isDiscountDvrChecked && (
                                            <span
                                                className="input-group-text mt-2"
                                                style={{ marginLeft: "10px", fontWeight: "bold" }}
                                            >
                                                Discount : {discountValueDVR}
                                                {"%"}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="ioTDevicesCount" className="pg-lable-style">
                                            IoT Devices Count
                                            {priceIoT != "0" && <span> ({priceIoT} per Unit)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="ioTDevicesCount"
                                            name="ioTDevicesCount"
                                            value={ioTDevicesCount}
                                            onChange={handleIoTDevicesCount}
                                            onBlur={handleBlurIoTDevicesCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                        {/* {proposalCounter != "" &&
                                        <div className="form-check m-3">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="applyDiscount"
                                                checked={isDiscountIotChecked}
                                                onChange={handleIotDiscountCheckboxChange}
                                            />
                                            <label className="form-check-label" htmlFor="applyDiscount">
                                                Apply Discount
                                            </label>
                                        </div>} */}


                                        {isDiscountIotChecked && (
                                            <span
                                                className="input-group-text mt-2"
                                                style={{ marginLeft: "10px", fontWeight: "bold" }}
                                            >
                                                Discount : {discountValueIoT}
                                                {"%"}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* <div className="col-12 col-md-6">
                                <div className="input-box form-floating mt-4">
                                    <input
                                        type="text"
                                        placeholder="Static IP Count"
                                        className="form-control input-text form-control-sm mt-1"
                                        id="staticIPCount"
                                        name="staticIPCount"
                                        value={staticIPCount}
                                        onChange={handleStaticIPCount}
                                        onBlur={handleBlurStaticIPCount}
                                    />
                                    <label htmlFor="staticIPCount" className="mt-2">
                                        Static IP Count
                                    </label>
                                    {isDiscountChecked && (
                                        <span
                                            className="input-group-text"
                                            style={{ marginLeft: "10px", fontWeight: "bold" }}
                                        >
                                            Discount:{discountValueStaticIP}
                                            {"%"}
                                        </span>
                                    )}
                                </div>
                            </div> */}

                                <div className="col-12 col-md-6">
                                    <div className="mt-4">
                                        <label htmlFor="devicePackCount" className="pg-lable-style">
                                            Device Pack Count
                                            {priceDevicePack != "0" && <span> ({priceDevicePack} per room)</span>}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Count"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="devicePackCount"
                                            name="devicePackCount"
                                            value={devicePackCount}
                                            onChange={handleDevicePackCount}
                                            onBlur={handleBlurDevicePackCount}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                        {proposalCounter != "" &&
                                            <div className="form-check m-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="applyDiscount"
                                                    checked={isDiscountDeviceChecked}
                                                    onChange={handleDeviceDiscountCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="applyDiscount">
                                                    Apply Discount
                                                </label>
                                            </div>}



                                        {isDiscountDeviceChecked && (
                                            <span
                                                className="input-group-text mt-2"
                                                style={{ marginLeft: "10px", fontWeight: "bold" }}
                                            >
                                                Discount : {discountValueDevicePack}
                                                {"%"}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* <div className="col-12 col-md-6">
                                <div className="input-box form-floating mt-4">
                                    <input
                                        type="text"
                                        placeholder="Wired LAN Ports Count"
                                        className="form-control input-text form-control-sm mt-1"
                                        id="wiredLANPortsCount"
                                        name="wiredLANPortsCount"
                                        value={wiredLANPortsCount}
                                        onChange={handleWiredLANPortsCount}
                                        onBlur={handleBlurWiredLANCount}
                                    />
                                    <label htmlFor="wiredLANPortsCount" className="mt-2">
                                        Wired LAN Ports Count
                                    </label>
                                    {isDiscountChecked && (
                                        <span
                                            className="input-group-text"
                                            style={{ marginLeft: "10px", fontWeight: "bold" }}
                                        >
                                            Discount:{discountValueWiredLAN}
                                            {"%"}
                                        </span>
                                    )}
                                </div>
                            </div> */}

                            </div>


                            <div className=" text-center mt-4 mb-4">
                                <button
                                    type="button"
                                    className="btn text-light submit-btn bg-dark mx-auto"
                                    onClick={handleCalculate}
                                >
                                    Calculate
                                </button>
                            </div>



                            {tableArea == true &&
                                <div className="mt-5">
                                    <div className="p-1">
                                        <div className="table-responsive calculate-table">
                                            <Table striped bordered hover responsive className="table-sm">
                                                <thead className="text-center table-dark">
                                                    <tr>
                                                        <th colSpan="5">Installation Charges: Spectra Pro-Fi Broadband for PG </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th colSpan="3">One-Time charges (OTC)</th>
                                                        <th colSpan="1">{otcPerRoombased}</th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="3">Security Deposit (SD)</th>
                                                        <th colSpan="1">{sdPerRoombased}</th>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>


                                    <div className="p-1">
                                        <div className="table-responsive calculate-table">
                                            <Table striped bordered hover responsive className="table-sm">
                                                {/* Table Header */}
                                                <thead className="text-center table-dark">
                                                    <tr>
                                                        <th colSpan="5">Recurring Charges: Spectra Pro-Fi Broadband for PG </th>
                                                    </tr>
                                                </thead>

                                                {/* Table Body */}
                                                <tbody>
                                                    <tr>
                                                        <th colSpan="2">Billing Frequency</th>
                                                        <th colSpan="2" className="table-primary">Half Yearly Advance</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Plan Name</th>
                                                        <th>Licence Count</th>
                                                        <th>Plan Rate (Per Month/ Licence)</th>
                                                        <th>Total Price</th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="4">Base Plan</th>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">{basePlan.label}</td>
                                                        <td className="text-end">{userPriceData.roomCount}</td>
                                                        <td className="text-end">{discountedBasePrice ? discountedBasePrice : listPrice || "0"}</td>
                                                        <td className="text-end">{discountedBasePrice ? userPriceData.roomCount * discountedBasePrice : userPriceData.roomCount * listPrice}</td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="4">Add-On Plans</th>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Smart TV Entertainment</td>
                                                        <td className="text-end">{smartTvCount ? smartTvCount : "0"}</td>
                                                        <td className="text-end">{smartTvCount ? TvPriceAfterDis ? TvPriceAfterDis : priceTV || "0" : "0"}</td>
                                                        <td className="text-end">{smartTvCount ? (+smartTVRes?.PriceAfterDiscount || 0) : "0"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">CCTV Camera Basic</td>
                                                        <td className="text-end">{cctvCount ? cctvCount : "0"}</td>
                                                        <td className="text-end">{priceCCTV}</td>
                                                        <td className="text-end">{cctvCount ? (+ccTvRes?.PriceAfterDiscount || 0) : "0"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">DVR/NVR Basic</td>
                                                        <td className="text-end">{dvrCount ? dvrCount : "0"}</td>
                                                        <td className="text-end">{priceDVR}</td>
                                                        <td className="text-end">{dvrCount ? (+dvrRes?.PriceAfterDiscount || 0) : "0"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary">Iot Device Basic</td>
                                                        <td className="text-end">{ioTDevicesCount ? ioTDevicesCount : "0"}</td>
                                                        <td className="text-end">{priceIoT}</td>
                                                        <td className="text-end">{(+iotRes?.PriceAfterDiscount || 0)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-primary"> Device Pack Basic</td>
                                                        <td className="text-end">{devicePackCount ? devicePackCount : "0"}</td>
                                                        <td className="text-end" >{discountValueDevicePack == "0" ? priceDevicePack : devicePackAfterDis}</td>
                                                        <td className="text-end">{devicePackCount ? (+devicePackRes?.TotalPriceIncRooms || 0) : "0"}</td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2" className="text-end">Total Reccuring Price (Per Month)</th>
                                                        <th colSpan="2" className="text-end">&#8377; {totalReccurringAmountNew.toFixed(2)}</th>
                                                    </tr>
                                                    <tr style={{ backgroundColor: "#6f9c68" }}>
                                                        <th colSpan="2" className="text-end"> Billing Amount (Half-Yearly Basis)</th>
                                                        <th colSpan="2" className="text-end">&#8377; {billingAmount}  </th>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2" className="text-end"> Effective Price (Per Room Per Month)</th>
                                                        <th colSpan="2" className="text-end"><span className="rupee">&#8377; {effectivePrice ? effectivePrice.toFixed(2) : 0}</span> </th>

                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>

                                    {/* {proposalCounter == "" &&
                                    <div className=" text-center mt-5 mb-5">
                                        <button
                                            type="button"
                                            className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                            onClick={handleCreateProduct}
                                        >
                                            Create Proposal
                                        </button>
                                    </div>}

                                {proposalCounter != "" &&
                                    <div className=" text-center mt-5 mb-5">
                                        <button
                                            type="button"
                                            className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                            onClick={handleUpdateProduct}
                                        >
                                            Update  Proposal
                                        </button>
                                    </div>} */}


                                </div>
                            }



                            {(proposalCounter == "" && tableArea == true) &&
                                <div className=" text-center mt-5 mb-5">
                                    <button
                                        type="button"
                                        className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                        onClick={handleCreateProduct}
                                        // disabled={tableArea == true || oppStatus !== "Open"}
                                        // disabled={tableArea == true || oppStatus !== "Open" || !basePlan}
                                        disabled={oppStatus !== "Open" || !basePlan}

                                    >
                                        Create Proposal
                                    </button>
                                </div>}

                            {(proposalCounter != "" && tableArea == true) &&
                                <div className=" text-center mt-5 mb-5">
                                    <button
                                        type="button"
                                        className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                        onClick={handleUpdateProduct}
                                        // disabled={tableArea == true || oppStatus !== "Open"}
                                        // disabled={tableArea == true || oppStatus !== "Open" || !basePlan}
                                        disabled={oppStatus !== "Open" || !basePlan}
                                    >
                                        Update  Proposal
                                    </button>
                                </div>}


                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default PriceCalculator1;